
const Wrapper = require('./Wrapper');
const { getLanguage } = require('../../entryPoints/layout/js/multilanguage');

class CityInputWrapper extends Wrapper {
    constructor(inputId) {
        super();

        this.element = document.getElementById(inputId);

        this.autocomplete = new google.maps.places.Autocomplete(this.element, {
            types: ['(cities)'],
            language: 'hy'
        });

        window.at = this;

        this.model = {
            id: null,
            fullname: null
        };

        this.required = true;

        this.initEvents();
    }

    get value() {
        return this.autocomplete.getPlace();
    }

    updateUI() {
        this.element.value = this.model.fullname ? this.model.fullname : '';
        this.autoValidation = true;
    }

    isValid() {
        return !this.required || Boolean(this.model.id);
    }

    validate() {
        if (this.isValid()) {
            this.element.classList.remove('invalid');
        } else {
            this.element.classList.add('invalid');
        }
    }

    initEvents() {
        this.autocomplete.addListener('place_changed', () => {
            let place = this.value;

            if (!place['place_id']) {
                this.element.value = ''
                return;
            }

            this.updateModel({
                id: place['place_id'],
                placeID: place['place_id'],
                fullname: place['formatted_address']
            });

            this.updateUI();
        });

        this.element.addEventListener('change', () => {
            if (this.element.value === "") {
                this.updateModel({
                    id: null,
                    placeID: null,
                    fullname: null
                });
                return;
            }
            this.updateUI.bind(this)();
        });


        this.element.setAttribute('autocomplete', 'offo')

        // need refactor
        const intID = setInterval(() => this.element.setAttribute('autocomplete', 'offo'), 100)

        setTimeout(() => clearInterval(intID), 2000)
    }
}

module.exports = CityInputWrapper;